import {
	type AutosaveDeleteResponseContract,
	type AutosaveLookupResponseContract,
	type AutosaveScopeContract,
	type AutosaveUpsertRequestContract,
	type AutosaveUpsertResponseContract,
} from '@workspace/shared-constants';

import { backendApi } from '@/utils/api';

export class AutosaveApiService {
	private readonly baseUrl = '/v2/autosave';

	public async saveDraft<TPayload>(
		payload: AutosaveUpsertRequestContract<TPayload>
	): Promise<AutosaveUpsertResponseContract> {
		const { data } = await backendApi.put<AutosaveUpsertResponseContract>(this.baseUrl, payload);

		return data;
	}

	public async fetchDraft<TPayload>(
		scope: AutosaveScopeContract
	): Promise<AutosaveLookupResponseContract<TPayload>> {
		const { data } = await backendApi.get<AutosaveLookupResponseContract<TPayload>>(this.baseUrl, {
			params: scope,
		});

		return data;
	}

	public async deleteDraft(scope: AutosaveScopeContract): Promise<AutosaveDeleteResponseContract> {
		const { data } = await backendApi.delete<AutosaveDeleteResponseContract>(this.baseUrl, {
			params: scope,
		});

		return data;
	}
}

export const autosaveApiService = new AutosaveApiService();
